import { ValidationProvider } from "vee-validate/dist/vee-validate.full";

export default {
  name: "binput",
  components: {
    ValidationProvider
  },
  props: [
    "name",
    "label",
    "type",
    "validation",
    "value",
    "icon",
    "placeholder",
    "focus"
  ],
  data() {
    return {
      confirmVal: "",
      confirm: false,
      vid: ""
    };
  },
  created() {
    if (typeof this.validation === "string") {
      if (this.validation && this.validation.includes("confirmed")) {
        let rulesArr = this.validation.split("|");
        let found = rulesArr.find(x => x.includes("confirmed"));
        this.$set(this, "vid", found.split(":")[1]);
        this.$set(this, "confirm", true);
      } else {
        this.$set(this, "confirm", false);
      }
    }
  },
  mounted() {
    if (this.focus) {
      this.$nextTick(() => {
        let el = this.$refs[this.name];
        if (el) {
          el.focus();
        }
      });
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      if (this.confirm && !newVal) {
        this.confirmVal = "";
      }
    }
  },
  methods: {
    UpdateValue(event) {
      if (event) {
        this.$emit("input", event.target.value);
      } else {
        this.$emit("input", this.value);
      }
    }
  }
};
